import domReady from '@wordpress/dom-ready';

function restoreOriginalHighlights() {
  document.querySelectorAll('.title-highlight').forEach((el) => {
    if (el.dataset.originalText) {
      const parent = el.parentNode;

      // Vérifie si le frère suivant est aussi un fragment du même texte
      if (
        el.nextSibling &&
        el.nextSibling.classList?.contains('title-highlight') &&
        el.nextSibling.dataset.originalText === el.dataset.originalText
      ) {
        const newSpan = document.createElement('span');
        newSpan.className = 'title-highlight';
        newSpan.dataset.originalText = el.dataset.originalText;
        newSpan.textContent = el.dataset.originalText;

        parent.insertBefore(newSpan, el);
        parent.removeChild(el.nextSibling);
        parent.removeChild(el);
      }
    }
  });
}

function splitTitleHighlights() {
  document.querySelectorAll('.title-highlight').forEach((el) => {
    // Ne pas retraiter si déjà scindé
    if (el.dataset.originalText && el.dataset.split === 'true') return;

    const rects = el.getClientRects();
    if (rects.length > 1) {
      const text = el.textContent;
      const range = document.createRange();
      range.setStart(el.firstChild, 0);

      for (let i = 1; i < text.length; i++) {
        range.setEnd(el.firstChild, i);
        const partialRects = range.getClientRects();
        if (partialRects.length > 1) {
          const firstPart = text.slice(0, i - 1);
          const secondPart = text.slice(i - 1);

          const span1 = document.createElement('span');
          span1.className = 'title-highlight';
          span1.textContent = firstPart;
          span1.dataset.originalText = text;
          span1.dataset.split = 'true';

          const span2 = document.createElement('span');
          span2.className = 'title-highlight';
          span2.textContent = secondPart;
          span2.dataset.originalText = text;
          span2.dataset.split = 'true';

          const parent = el.parentNode;
          parent.insertBefore(span1, el);
          parent.insertBefore(span2, el);
          parent.removeChild(el);
          break;
        }
      }
    } else if (!el.dataset.originalText) {
      el.dataset.originalText = el.textContent;
    }
  });
}

// Gestion du resize
function handleResize() {
  restoreOriginalHighlights();
  splitTitleHighlights();
}

window.addEventListener('resize', () => {
  // Petit délai pour laisser le temps au layout de se stabiliser
  setTimeout(handleResize, 100);
});

domReady(() => {
  // Lancer au chargement initial
  handleResize();
});
